import { Spin } from '@/components/Loading/ShieldSpin';
import { PageFooter } from '@/components/PageFooter';
import { useNavigateWithSearch } from '@/hooks/useNavigateWithSearch';
import { useSearch } from '@/hooks/useSearch';
import { changeLang, i18n } from '@/locales';
import { getBuriedPointInfo, isPromotingAds, isSemHostname } from '@/utils';
import querystring from "query-string";
import React, { useEffect, useMemo, useState } from 'react'

export const RegisterV2: React.FC = () => {

    require('@authing/react-ui-components/lib/index.min.css');
    const { Guard } = require('@authing/react-ui-components')

    const config = window.__config__;
    const host = window.location.origin

    const search = useSearch()
    const [appId, setAppId] = useState<string>('')
    const [loading, setLoading] = useState<boolean>(true)
    const navigate = useNavigateWithSearch();
    const [showFooter, setShowFooter] = useState(false)

    const lang = useMemo(() => i18n.language, [])

    useEffect(() => {
        setAppId(search?.app_id as string)
    }, [appId, search])

    const onLangChange = ({ key }: any) => {
        changeLang(key);
    };

    const isSem = isSemHostname();
    const promotingAds = isPromotingAds();
    const buriedPointInfo = getBuriedPointInfo();

    const context = {
        isSem,
        pa: promotingAds,
        ...buriedPointInfo,
    };


    useEffect(() => {
        const query = querystring.parse(window.location.search);
        const path = query["goto"];
        if (path) {
            navigate(path as string);
        }
    }, [config, navigate]);

    useEffect(() => {
        if (appId)
            setLoading(false)
    }, [appId])




    return <>
        {
            loading ?
                <Spin />
                : <>
                    <Guard
                        appId={appId}
                        config={{
                            host, lang, defaultScenes: 'register', registeContext: context
                        }}
                        onLangChange={onLangChange}
                        onBeforeChangeModule={(key: any) => {
                            if (key === "login") {
                                navigate('/login')
                            }
                        }}
                        onLoad={() => {
                            setShowFooter(true)

                        }}
                    />
                    {showFooter && <PageFooter />}
                </>

        }
    </>
}